// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import Heading from './Heading'
import { DeviceFieldWrapper } from 'components/SearchAndSelect/Sets/common/styles'
import AntennaField from 'components/SearchAndSelect/Sets/common/AntennaField'
import RadioField from 'components/SearchAndSelect/Sets/common/RadioField'
import icon from 'images/path-details-path.png'

import {
  LabeledInput,
  MultiSelectFromState,
  SelectFromState,
} from 'components/Form'

const Path = ({ idRoot, sourceForm }) => (
  <ul className={'path-db-search-section-path path-db-search-section display-flex flex-wrap-wrap'}>
    <li className={'width-100'}>
      <Heading
        heading={'Path Information'}
        iconPath={icon}
        idRoot={`${idRoot}path`} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}path-name`}
        label={'Path Name'}
        name={'pathName'} />
    </li>
    <li className={'path-db-search-input-column path-db-license-basis-search-input-margin'}>
      <Field
        component={MultiSelectFromState}
        id={`${idRoot}license-basis`}
        label={'License Basis'}
        name={'licenseBasisId'}
        labelKey={'licenseBasis'}
        targetSet={['regulatorySettings', 'licenseBases']}
        valueKey={'licenseBasisId'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}frequency`}
        label={'Frequency (MHz)'}
        name={'frequency'}
        placeholder={'Frequency'} />
    </li>
    <DeviceFieldWrapper className={'path-db-search-input-column display-flex'}>
      <Field
        component={RadioField}
        idRoot={`${idRoot}radio`}
        name={'radioField'}
        sourceForm={sourceForm} />
    </DeviceFieldWrapper>
    <li className={'path-db-search-input-column'}>
      <Field
        component={SelectFromState}
        emptyOptionLabel={'-Select-'}
        id={`${idRoot}polarization`}
        name={'polarizationId'}
        selectLabel={'Polarization'}
        targetSet={['frequencySettings', 'polarizations']}
        valueKeyRoot={'polarization'} />
    </li>
    <DeviceFieldWrapper className={'path-db-search-input-column display-flex'}>
      <Field
        component={AntennaField}
        idRoot={`${idRoot}antenna`}
        name={'antennaField'}
        sourceForm={sourceForm} />
    </DeviceFieldWrapper>
  </ul>
)

Path.propTypes = {
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default Path
